<template>
  <div class="topbar-right">
    <div class="topbar-right-btn">
      <template v-if="this.$store.state.isLogin">
        <el-button type="text" @click="dialogSummary = true">上传总结</el-button>
        <el-button type="text" @click="downloadLogLink">下载记录</el-button>
        <el-button type="text" @click="dialogChangePwdVisible = true">修改密码</el-button>
        <el-button type="text" @click="logout">退出登录</el-button>
      </template>
      <template v-else>
        <el-button type="text" @click="dialogLoginVisible = true">登录</el-button>
      </template>
    </div>
    <el-dialog customClass="login-form" title="登录" :visible.sync="dialogLoginVisible" :append-to-body="true" width="500px" :center="true" :before-close="handleLoginClose">
      <el-form :model="loginForm" label-width="80px" :rules="loginFormRules" ref="loginForm">
        <el-form-item label="用户名：" prop="username">
          <el-input type="text" v-model="loginForm.username" placeholder="请输入用户名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密　码：" prop="password">
          <el-input type="password" v-model="loginForm.password" placeholder="请输入用户名" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitLoginForm('loginForm')">登 录</el-button>
      </span>
    </el-dialog>
    <el-dialog customClass="login-form" title="修改密码" :visible.sync="dialogChangePwdVisible" :append-to-body="true" width="500px" :center="true" :before-close="handleChangePwdClose">
      <el-form :model="changePwdForm" label-width="100px" :rules="changePwdFormRules" ref="changePwdForm">
        <el-form-item label="旧密码：" prop="oldPassword">
          <el-input type="password" v-model="changePwdForm.oldPassword" placeholder="请输入旧密码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPassword">
          <el-input type="password" v-model="changePwdForm.newPassword" placeholder="请输入新密码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPassword">
          <el-input type="password" v-model="changePwdForm.confirmPassword" placeholder="请确认密码" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitChangePwdForm('changePwdForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上传总结 -->
    <el-dialog customClass="login-form" title="上传总结" :visible.sync="dialogSummary" :append-to-body="true" width="530px" :center="true" :before-close="handleSummaryClose">
      <el-form :model="summaryForm" label-width="120px" :rules="summaryFormRules" ref="summaryForm">
        <el-form-item label="汇总描述：" prop="content">
          <el-input type="textarea" v-model="summaryForm.content" placeholder="请输入汇总描述" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="文件上传：" prop="fileUrl">
          <el-upload drag action="#" :before-upload="uploadBefore" ref="upload" :on-success="uploadSuccess" :on-error="uploadError" :on-remove="uploadRemove" :disabled="uploadDisabled" name="file" :file-list="fileList" :auto-upload="true" :http-request="uploadRequest" multiple :limit="1">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              <p v-show="!isUploading">将文件拖到此处，或<em>点击上传</em></p>
              <p v-show="isUploading">文件上传中<i class="el-icon-loading"></i></p>
            </div>
            <div class="el-upload__tip" slot="tip">上传文件不能大于{{ uploadLimitSize }}MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="summarySubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { login } from '@/api/login'
import { getInfo, changePwd } from '@/api/user'
import { summaryAdd, uploadFile } from '@/api/summary'

export default {
  data() {
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.changePwdForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isUploading: false,
      uploadDisabled: false,
      fileList: [],
      dialogSummary: false,
      dialogLoginVisible: false,
      dialogChangePwdVisible: false,
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
      },
      loginForm: {
        username: '',
        password: ''
      },
      changePwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      changePwdFormRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validatePassword, trigger: 'blur' }
        ],
      },
      summaryForm: {
        content: '',
        fileUrl: '',
        fileSize: ''
      },
      summaryFormRules: {
        content: [
          { required: true, message: '请填写汇总描述', trigger: 'blur' }
        ],
        fileUrl: [
          { required: true, message: '请先上传文件', trigger: 'blur' }
        ]
      },
      uploadLimitSize: 100
    }
  },
  computed: {

  },
  created () {
    if(window.localStorage.getItem('isLogin')){
      this.$store.state.isLogin = window.localStorage.getItem('isLogin')
    }
  },
  methods: {
    // 文件上传
    uploadRequest(params) {

      this.isUploading = true
      this.uploadDisabled = true

      const formData = new FormData()

      formData.append('file', params.file)
      formData.append('type', 'summary')

      uploadFile(formData).then(res => {
        params.onSuccess(res)
      }).catch(({err}) => {
        params.onError(err)
      })
      
    },
    // 上传文件校验
    uploadBefore(file) {
      const isLt = file.size / 1024 / 1024 <= this.uploadLimitSize

      if( !isLt ) {
        this.$message.error('上传文件不能大于' + this.uploadLimitSize + 'MB')
      }

      return isLt
    },
    // 删除选择的文件
    uploadRemove() {
      this.fileList = []
      this.isUploading = false
      this.uploadDisabled = false
      this.summaryForm.fileUrl = ''
      this.summaryForm.fileSize = ''
    },
    // 上传成功
    uploadSuccess(res) {
      if (res.data.code == 200) {
        this.$message.success('上传成功')
        this.summaryForm.fileUrl = res.data.fileName
        this.summaryForm.fileSize = res.data.fileSize
        this.isUploading = false
        this.uploadDisabled = false
      }
    },
    // 上传失败
    uploadError(err) {
      this.$message.error('文件上传失败')
    },
    // 提交总结
    summarySubmit() {
      this.$refs['summaryForm'].validate(valid => {
        if (valid) {
          summaryAdd(this.summaryForm).then(res => {
            if(res.data.code == 200){
              this.dialogSummary = false
              this.$refs['summaryForm'].resetFields()
              this.fileList = []
              this.$message.success('提交成功')
            }
          })
        }
      })
    },
    // 关闭上传总结
    handleSummaryClose(done){
      this.fileList = []
      this.isUploading = false
      this.uploadDisabled = false
      this.$refs['summaryForm'].resetFields()
      this.dialogSummary = false
    },
    // 下载记录跳转
    downloadLogLink(){
      this.$router.push({
        query: {'c':'DownloadLog','centiare':this.$route.query.centiare,'contentID':this.$route.query.contentID}
      })
    },
    // 提交登录
    submitLoginForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          login({
            username: this.loginForm.username,
            password: this.loginForm.password
          }).then(res => {
            if(res.data.code == 200){
              this.$message({
                message: '登录成功！',
                type: 'success'
              });
              window.localStorage.setItem('isLogin', true)
              window.localStorage.setItem('token',res.data.token)
              this.$store.state.isLogin = true
              this.$refs[formName].resetFields()
              // 登录成功后获取用户信息
              getInfo().then(res => {
                if(res.data.code == 200){
                  this.$store.state.nickName = res.data.user.nickName
                  this.$store.state.deptName = res.data.user.dept.deptName
                  // location.reload()
                }else{
                  console.log('用户信息获取失败')
                }
              })
              this.dialogLoginVisible = false
            } else {
              this.$message.error('登录失败')
            }
          })
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    // 关闭登录框
    handleLoginClose(done) {
      this.$refs['loginForm'].resetFields()
      this.dialogLoginVisible = false
    },
    // 退出登录
    logout() {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('isLogin')
      this.$store.state.isLogin = false
      this.$store.state.nickName = ''
      this.$message({
        message: '退出登录',
        type: 'success',
        // onClose: function () { 
        //   location.reload()
        //  }
      });
      location.reload()
    },
    // 关闭修改密码框
    handleChangePwdClose(done) {
      this.$refs['changePwdForm'].resetFields()
      this.dialogChangePwdVisible = false
    },
    // 修改密码
    submitChangePwdForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          changePwd({
            oldPassword: this.changePwdForm.oldPassword,
            newPassword: this.changePwdForm.newPassword
          }).then(res => {
            if(res.data.code == 200){
              this.$refs['changePwdForm'].resetFields()
              this.dialogChangePwdVisible = false
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            } else {
              this.$message.error('修改失败')
            }
          })
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    }
  }
}
</script>
<style scoped>
.topbar-right {
  position: absolute;
  top: 77px;
  right: 60px;
  z-index: 1;
}
.topbar-right .topbar-right-btn .el-button,.topbar-right .topbar-right-btn a {
  font-size: 18px;
  color: #c01509;
  font-weight: bold;
}
.topbar-right .topbar-right-btn a {
  display: inline-block;
  margin: 0 12px;
}
.dialog-footer .el-button {
  background-color: #fff1e1;
  border: solid 1px #ea6613;
  color: #c01509;
  width: 100%;
}
</style>
<style>
.login-form .el-dialog__header {
  text-align: center;
}
.login-form .el-dialog__title {
  font-size: 30px;
  color: #c01509;
  text-align: center;
}
</style>
